<template>
  <RawVisualization
    v-if="serverUrl"
    :server-url="serverUrl"
    :study-uid="imagingStudy.identifier[0].value.substr(8)"
    :series-uid="imagingStudy.series[0].uid"
    :height="height"
    :hide-loader="hideLoader"
    :float-mode="floatMode"
    ref="viewer"
    @loading:rendered="$emit('loading:rendered')"
    @loading:search="$emit('loading:search')"
    @loading:metadata="$emit('loading:metadata')"
    @loading:slide-not-found="$emit('slide-not-found')"
  ></RawVisualization>
</template>

<script>
import { LOAD, FIND } from "@/store/modules/fhir";
import RawVisualization from "@/components/slide/RawVisualization";

export default {
  components: { RawVisualization },
  props: {
    imagingStudy: { type: Object, required: true },
    hideLoader: { type: Boolean, default: false },
    height: { type: Number, default: null },
    floatMode: Boolean,
  },
  data() {
    return {
      serverUrl: null
    };
  },
  computed: {
    viewer() {
      return this.$refs.viewer.viewer;
    },
    map() {
      return this.$refs.viewer.viewer.map;
    }
  },
  async mounted() {
    await this.$store.dispatch(LOAD, this.imagingStudy.endpointResource);
    this.serverUrl = await this.$store.getters[FIND](
      this.imagingStudy.endpointResource.reference
    ).address;
  }
};
</script>

<style lang="scss" scoped></style>
